import { hasStoredProvisioningRequestId } from '@/components/signup/site-activation/hooks/site-activation-context';
import { useCohort } from '@/components/user-context/helpers/cohorts';
import { ExperimentView } from '@/utils/experiment/experiment-view';
import { experiments } from '@/utils/experiment/manifest';

import { LoggedInJiraNewUser } from '../components/logged-in-jira-new-user';

import { CurrentProductJoinableUser } from './current-product-joinable-user';
import { CurrentProductUser } from './current-product-user';
import { DeferSiteNameVariant } from './defer-site-name-variant';
import { LoggedInJiraFreeExistingSitesUser } from './existing-sites-user';

export const LoggedInJiraFree = () => {
	const cohort = useCohort(true);

	if (cohort === 'current-product-user') {
		return <CurrentProductUser />;
	}

	if (cohort === 'current-product-joinable-user') {
		return <CurrentProductJoinableUser />;
	}

	// spark-defer-site-name-v2 (TWCG-2407): if provisioning already started in this
	// session (the user navigated back to signup after auto-activation), do not
	// re-enter the new-user/experiment path — fall through to the existing-sites
	// screen instead of re-mounting the deferred-naming loader.
	if (cohort === 'new-user' && !hasStoredProvisioningRequestId()) {
		return (
			<ExperimentView
				experiment={experiments.sparkDeferSiteNameV2}
				indeterminate={<LoggedInJiraNewUser />}
				render={(isEnabled) => (isEnabled ? <DeferSiteNameVariant /> : <LoggedInJiraNewUser />)}
			/>
		);
	}

	if (cohort) {
		return <LoggedInJiraFreeExistingSitesUser />;
	}

	return null;
};
